// MP316i — "Preview" chip for surfaces the viewer sees because their org
// is on a feature flag's beta channel (`isBeta` on the resolved flag).
// One component so the sidebar row and the page hero render the same
// object. Amber is the platform's beta tone (semantic scale, not a page
// theme — see feedback_no_green_orange_red_page_themes).

export function PreviewBadge({ className = '' }: { className?: string }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full border border-amber-400/70 bg-amber-50 px-1.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800 dark:border-amber-500/60 dark:bg-amber-950/40 dark:text-amber-300 ${className}`}
      title="Preview — enabled for your organisation as part of the beta. Behaviour may change."
    >
      Preview
    </span>
  );
}
